import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OrderType } from "../types/OrderType";
import { apiClient } from "src/utils/Api/apiClient";

interface orderState {
        orders: Array<OrderType>;
        ordersLoading: boolean;
        ordersError: string | null;
}

const initialState: orderState = {
        orders: [],
        ordersLoading: true,
        ordersError: null
}

export const getOrders = createAsyncThunk(
        'order/getOrders',
        async (orderData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`order/getOrders/${orderData}`);
                        return response.data;
                } catch (orderError: any) {
                        return rejectWithValue(orderError.message || 'An error occured');
                }
        }
);

export const getOrdersByDealerId = createAsyncThunk(
        'order/getOrdersByDealerId',
        async (orderData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`order/getOrdersByDealerId/${orderData}`);
                        return response.data;
                } catch (orderError: any) {
                        return rejectWithValue(orderError.message || 'An error occured');
                }
        }
);

export const getOrdersByEndUserID = createAsyncThunk(
        'order/getOrdersByEndUserID',
        async (orderData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`order/getOrdersByEndUserID/${orderData}`);
                        return response.data;
                } catch (orderError: any) {
                        return rejectWithValue(orderError.message || 'An error occured');
                }
        }
);

const ordersSlice = createSlice({
        name: 'orders',
        initialState,
        reducers: {
                orderReset: () => initialState,
        },
        extraReducers: (builder) => {
                //get orders from server
                builder.addCase(getOrders.pending, (state) => {
                        state.ordersLoading = true;
                        state.ordersError = null;
                });
                builder.addCase(getOrders.fulfilled, (state, action) => {
                        state.ordersLoading = false;
                        state.orders = action.payload;
                });
                builder.addCase(getOrders.rejected, (state, action) => {
                        state.ordersLoading = false;
                        state.ordersError = action.payload as string;
                });

                //get orders from server by dealer id
                builder.addCase(getOrdersByDealerId.pending, (state) => {
                        state.ordersLoading = true;
                        state.ordersError = null;
                });
                builder.addCase(getOrdersByDealerId.fulfilled, (state, action) => {
                        state.ordersLoading = false;
                        state.orders = action.payload;
                });
                builder.addCase(getOrdersByDealerId.rejected, (state, action) => {
                        state.ordersLoading = false;
                        state.ordersError = action.payload as string;
                });

                //get orders from server by enduser id
                builder.addCase(getOrdersByEndUserID.pending, (state) => {
                        state.ordersLoading = true;
                        state.ordersError = null;
                });
                builder.addCase(getOrdersByEndUserID.fulfilled, (state, action) => {
                        state.ordersLoading = false;
                        state.orders = action.payload;
                });
                builder.addCase(getOrdersByEndUserID.rejected, (state, action) => {
                        state.ordersLoading = false;
                        state.ordersError = action.payload as string;
                });

        }
});

export const { orderReset } = ordersSlice.actions;
export default ordersSlice.reducer;
